<div class="pre-qualify" *transloco="let t">
	<div class="step-indicator op-right op-mt-10">
		<span class="current-step"> {{ this.currentStep }} </span
		><span id="noOfSteps">{{ t('PRE_QUALIFY.totalSteps', { totalSteps: totalSteps }) }}</span>
	</div>
	<mat-progress-bar class="green-progress" mode="determinate" value="{{ progressBarValue }}"></mat-progress-bar>
	<router-outlet></router-outlet>
</div>
